import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import { GET_RECEIPT_REQUEST, GET_RECEIPT_SUCCESS, GET_RECEIPT_FAILURE, COMMON_FAILURE } from '../../actions';

import { receiptService } from '../../services';

export type getReceiptActionType = {
  type: typeof GET_RECEIPT_REQUEST;
  memberId: string;
  targetMonth: number;
  paymentDate: string;
  history: string[];
};

function* getReceipt(action: getReceiptActionType): Generator<unknown> {
  try {
    const res = yield call(receiptService(action).getReceipt);
    yield put({
      type: GET_RECEIPT_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_RECEIPT_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetReceipt() {
  yield takeLatest(GET_RECEIPT_REQUEST, getReceipt);
}
export default function* getReceiptSaga(): Generator<unknown> {
  yield all([fork(watchGetReceipt)]);
}
